import { RouteConfig } from 'vue-router';

import RouterView from '@/components/layout/Router.vue';
import { profileRoute } from './profiles/profile.route';
import { profilesRoute } from './profiles/profiles.route';

export const profilesContainerRoute: RouteConfig = {
  path: 'profiles',
  children: [profilesRoute, profileRoute],
  component: RouterView,
  meta: {
    authorized: true,

    config: {
      title: `menu.profile-list`,
      icon: 'fal fa-users',
      name: 'profiles',
      permissions: ['USER.LIST'],
      group: 'Użytkownicy'
    },

    breadcrumb: {
      title: 'breadcrumbs.profiles.list',
      name: 'profiles'
    }
  }
};
